import Loadable from 'react-loadable';
import ComponentLoading from 'components/ComponentLoading/ComponentLoading';
var LoadableOrgUsers = Loadable({
  loader: function loader() {
    return import('../OrgUsers.jsx');
  },
  loading: ComponentLoading
});
export default LoadableOrgUsers;